export enum EngagementAgeApiEnum {
    LATEST = 'latest',
    INGESTION = 'ingestion',
    ONE_HOUR = 'one_hour',
    EIGHT_HOUR = 'eight_hour',
    ONE_DAY = 'one_day',
    TWO_DAYS = 'two_days',
    DAYS_7 = 'seven_days',
    THIRTY_DAYS = 'thirty_days'
}
